import { TextToVoiceIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import TTVButton from './IconButton';

const TextToVoiceToggle = ({ isSelected, onClick = () => {} }) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <div data-name="text-to-voice-toggle">
      <TTVButton
        grow={false}
        btnType="secondary"
        noMargin
        onClick={handleClick}
        selected={isSelected}
        dataName="transcript-ttv-button"
        tooltip="Text to Voice"
      >
        <Box as="span">
          <TextToVoiceIcon height={14} width={14} />
        </Box>
      </TTVButton>
    </div>
  );
};

export default TextToVoiceToggle;
